import crashRequestParams, {
	FilterNames,
	LinkedCrash,
	Priority,
	SortField,
	unlinkCrashDto,
} from "dto/crashRequestDto";
import { crashArchiveDto } from "src/dto/crashDto";
import {
	deleteWithAuthHasBody,
	getWithAuth,
	postWithAuth,
	putWithAuth,
} from "utilities/api";

export async function getCrashes(
	accessToken: string,
	params: crashRequestParams,
	signal: AbortSignal | null = null
) {
	//console.log(JSON.stringify(params,function replacer(key, value) { return value}));
	const url = window.env.baseURL + "crash/";
	return postWithAuth(url, accessToken, params, signal).then((response) => {
		return response;
	});
}

export async function getCrashById(accessToken: string, id: number) {
	const url = window.env.baseURL + "crash/" + id;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function getCrashBasicDataById(accessToken: string, id: number) {
	const url = window.env.baseURL + "crash/" + id + "/basic";
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function getCrashOtherDataById(accessToken: string, id: number) {
	const url = window.env.baseURL + "crash/" + id + "/other";
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function symbolicateCrash(accessToken: string, id: number) {
	const url = window.env.baseURL + "crash/symbolicate/" + id;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function symbolicateCrashesOfApp(accessToken: string, id: number) {
	const url = window.env.baseURL + "crash/symbolicate/app/" + id;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function updateArchiveStatus(
	accessToken: string,
	params: crashArchiveDto
) {
	const url = window.env.baseURL + "crash";
	return putWithAuth(url, accessToken, params).then((response) => {
		return response;
	});
}

export async function updateCrashPriority(
	accessToken: string,
	id: number,
	params: { priority: Priority }
) {
	const url = window.env.baseURL + "crash/" + id + "/priority";
	return putWithAuth(url, accessToken, params).then((response) => {
		return response;
	});
}

export async function GetListOfArchivedCrasheshWithThreshold(
	accessToken: string,
	currentPageNumber: number,
	itemPerPage: number
) {
	const url =
		window.env.baseURL +
		`crash/archived-by-threshold?currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}`;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function getLinkedCrashes(
	accessToken: string,
	id: number,
	currentPageNumber: number,
	itemPerPage: number,
	sortField: SortField,
	isAscending: boolean
) {
	const url =
		window.env.baseURL +
		`crash/${id}/linked-crashes?currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}&sortField=${sortField}&isAscending=${isAscending}`;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function getUnlickedCrashes(
	accessToken: string,
	id: number,
	searchString: string,
	searchField: FilterNames,
	currentPageNumber: number,
	itemPerPage: number,
	sortField: SortField,
	isAscending: boolean
) {
	const url =
		window.env.baseURL +
		`crash/${id}/unlinked-crashes?searchString=${searchString}&searchField=${searchField}&currentPageNumber=${currentPageNumber}&itemPerPage=${itemPerPage}&sortField=${sortField}&isAscending=${isAscending}`;
	return getWithAuth(url, accessToken).then((response) => {
		return response;
	});
}

export async function addLinkedCrash(accessToken: string, params: LinkedCrash) {
	const url = window.env.baseURL + "crash/link";
	return postWithAuth(url, accessToken, params).then((response) => {
		return response;
	});
}

export async function removeLinkedCrash(
	accessToken: string,
	params: unlinkCrashDto
) {
	const url = window.env.baseURL + "crash/link";
	return deleteWithAuthHasBody(url, accessToken, params).then((response) => {
		return response;
	});
}
